import { saveBankAccounts } from 'commons/service/bank/application'
import { ApplicationSaveBankAccountsPayload } from 'commons/types/DTO/bank/applications/bankAccounts/bankAccounts'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSaveRelationshipBankAccounts: WriteHook<ApplicationSaveBankAccountsPayload, unknown> = (opts) =>
  useMutationManager<ApplicationSaveBankAccountsPayload, unknown>(saveBankAccounts, opts)
